// Early capture of the Supabase recovery signal.
//
// The Supabase client parses `type=recovery` from the URL hash asynchronously
// and then strips the hash. Because the client is created lazily (Proxy) and
// route chunks load lazily too, the reset-password page module can miss both
// the hash and the PASSWORD_RECOVERY event. This module is imported by the
// root route (entry chunk), so its module-scope code always runs before the
// Supabase client exists — the hash is guaranteed to still be present.

const KEY = "__lcPwRecovery";

declare global {
  interface Window {
    [KEY]?: boolean;
  }
}

export function initRecoveryFlag(): void {
  if (typeof window === "undefined") return;
  const h = window.location.hash || "";
  if (/(?:^|[#&])type=recovery(?:&|$)/.test(h) || h.includes("type=recovery")) {
    window[KEY] = true;
  }
  // Bonus: catch PASSWORD_RECOVERY for SPA-side flows (e.g. the client was
  // already created before this module ran, or recovery happens in-tab).
  void import("@/integrations/supabase/client").then(({ supabase }) => {
    supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") window[KEY] = true;
    });
  });
}

/** True when this page load arrived via a recovery link. */
export function hasRecoveryFlag(): boolean {
  if (typeof window === "undefined") return false;
  return window[KEY] === true;
}
